$(function(){

  //PC スライドメニュー
  openSideSlidemenu();
  //フェードイン表示
  var fadeItem = $('.fade');
  displayFadein(fadeItem);
  //スムーススクロール
  smoothScroll();
  //ページ上部の余白調整
  adjustMarginsTopOfPage();
  //Top page
  if($( '.template-index' ).length){
    if( isPC() ){
      // 「NEW IN」のスライド
      var newInCollection = '#shopify-section-1611631661da187d05';//コンテンツのid
      var newInSlideShowPC = 6;//1度表示させる枚数
      collectionSlider(newInCollection,newInSlideShowPC);
    }
    //トップページのフェードイン表示
    var fadeToppageLargeItem = $('#shopify-section-161163326435f99469 .grid__item,#shopify-section-1611633347c413b01a .grid__item,#shopify-section-image-bar .grid__item');
    displayFadein(fadeToppageLargeItem);
  }
  //Product page
  if($('.template-product').length){
    //商品画像のスライダー
    mainItemImageSlider();
    //商品読み込み後に表示
    displayedAfterLoadingProduct();
    //スウォッチ切替時に予約商品の文言変更
    displayPreorderBtn();
    $(document).on('click', '.swatch-view-item',  function(){
      displayPreorderBtn();
    });
    // 商品詳細トグル
    $('.product-detail-toggle-body').hide();
    $('.product-detail-toggle-head').on('click', function(){
      $(this).toggleClass('open');
      $(this).next('.product-detail-toggle-body').slideToggle('fast');
    });

    // サイズガイド
    $('.size-guide-modal-open').click(function(){
      $('.size-guide-modal').addClass('show');
      $('body').addClass('modal-open');
    });
    $('.size-guide-modal-close').click(function(){
      $('.size-guide-modal').removeClass('show');
      $('body').removeClass('modal-open');
    });
    $(document).on('click', function(e) {
      if($('.size-guide-modal').hasClass('show')){
        if(!$(e.target).closest('.modal-dialog,.size-guide-modal-open').length) {
          //ここに外側をクリックしたときの処理
          $('.size-guide-modal').removeClass('show');
          $('body').removeClass('modal-open');
        } else {
          //ここに内側をクリックしたときの処理
        }
      }
    });
    $(".js-size-guide-modal").contentsSmoothScroll({
      body: $("#size-guide-modal"),
      scrollTo: function() {
        return $("#" + $(this).data("target")).offset().top - $("#size-guide-modal").offset().top + $("#size-guide-modal").scrollTop()
      }
    });
    $(".js-size-guide-modal-top").contentsSmoothScroll({
      body: $("#size-guide-modal")
    });

  }

  // Register
  if($('.template-customers-register').length){
    window.addEventListener('pageshow',()=>{
      $('.js-submit-agreement').prop('checked', false);
    });
    $('.js-submit-agreement').change(function(){
      agreeBeforeSubmit();
    });

  }


});

$(window).on('load',function(){
  //日付処理・アイコン処理等
  processingMultipleGetServerDate();
  //Top page
  if($( '.template-index' ).length){
    // 「Best Sellers」のスライド
  	var bestSellersCollection = '#shopify-section-1611635533f7061bff';//コンテンツのid
    var bestSellersSlideShowPC = 4;//1度表示させる枚数
    collectionSlider(bestSellersCollection,bestSellersSlideShowPC);
  }
  //31sdm page
  if($( '.page-31sdm' ).length){
    if( isPC() ){
      // 「NEW ARRIVAL」のスライド
      var newInCollection = '.newarrival-31sdm';//コンテンツのid
      var newInSlideShowPC = 6;//1度表示させる枚数
      collectionSlider(newInCollection,newInSlideShowPC);
    }
  }

  //商品詳細ページ
  if( $('.template-product').length ){
    //PCのとき
    if(isPC()){
      setTimeout(function(){
        //サムネイル画像のスクロール
        var csObj = new Object();
        csObj.horizontalScroll=true;
        $(".scroll-area").mCustomScrollbar(csObj);
      },1000);
    }
    //商品画像の矢印ボタンの処理
    processingImageArrowButton();
  }
});



//PC
function isPC(){
  return $(window).width() > 749;
}
// トップページか判定
function isTopPage(){
  var homeUrlPathName = '/';
  // 最後のスラッシュを消す（デモ環境対策）
  homeUrlPathName = homeUrlPathName.slice(0, homeUrlPathName.length-1);
  var regex = '^' + homeUrlPathName + '\/?$';
  return Util.isPageRegex(regex);
}

/****************************************************************************
* PC スライドメニュー
****************************************************************************/
function openSideSlidemenu(){

  //クリックしたら
  $('.js-slidemenu-toggle').on('click',function(){

    //activeの場合、activeクラスを外す
    if( $(this).hasClass('is-active')){
      $(this).removeClass('is-active');
    //activeでない場合
    }else{
      //activeクラスを外す
      $('.js-slidemenu-toggle').removeClass('is-active');
      //activeクラスを付与
      $(this).addClass('is-active');
    }
    
  });
}


/****************************************************************************
* トップ「New IN」のスライド
****************************************************************************/
function collectionSlider(thisCollection,slideShowPC){
  
  //一度で表示する枚数
  var slideShowSP = 1;

  $(thisCollection+' .grid').slick({
    infinite: false,
    speed: 1000,
    slidesToShow: slideShowPC,
    slidesToScroll: slideShowPC,
    arrows: true,
    responsive: [
      {
        breakpoint: 749,
        settings: {
          slidesToShow: slideShowSP,
          slidesToScroll: slideShowSP,
        }
      }
    ]
  });
  
  // スライダー処理後にコンテンツ表示
  $(thisCollection+' .grid').css('opacity','1');

}

/****************************************************************************
* 商品画像のスライダー（SP）
****************************************************************************/
function mainItemImageSlider(){
  $('.js_mainimg_detail').flexslider({
      animation: "slide",
      controlNav: false,
      animationLoop: false,
      slideshow: false,
      sync: ".js_thumbimg_detail",
  });

  $('.js_thumbimg_detail').flexslider({
      directionNav: false,
      animation: "slide",
      controlNav: false,
      animationLoop: false,
      slideshow: false,
      itemWidth: 42,
      itemMargin: 8,
      asNavFor: '.js_mainimg_detail'
  });
}

/****************************************************************************
* フェードイン表示
****************************************************************************/
function displayFadein(fadeItem){
  var fadeDoneClass = "fade-done";
  
  // コンテンツをfade表示
  $(fadeItem).on('inview', function(event, isInView, visiblePartX, visiblePartY) {
    if(isInView){
      if(!$(this).hasClass(fadeDoneClass)){
        $(this).stop().addClass(fadeDoneClass);
      }
    }
  });
}

/****************************************************************************
* スムーススクロール
****************************************************************************/
function smoothScroll(){
  //ページ内リンクをクリックしたら
  $('a[href^="#"]').not('.size-guide-modal a').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    //処理終了
    if(!target.offset()){
      return false;
    }
    var position = target.offset().top;
    //ゆっくりスクロール
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
    
  });
}

$.fn.contentsSmoothScroll = function(t) {
  var e = (t = $.extend({}, {
    speed: 500,
    body: $([document.documentElement, document.body]),
    scrollTo: 0
  }, t)).body instanceof jQuery ? t.body : $(t.body);
  return $(this).on("click", function() {
    e.animate({
      scrollTop: "function" != typeof t.scrollTo ? t.scrollTo : t.scrollTo.apply(this, t)
    }, t.speed)
  }), this
}

/****************************************************************************
* 会員登録時に同意必須
****************************************************************************/
function agreeBeforeSubmit() {
  var agreement = $('.js-submit-agreement').prop('checked');
  if(agreement) {
    // 同意チェックされていればボタンを利用可に変更
    $('.js-agree-submit-btn').prop('disabled', false);
  } else {
    $('.js-agree-submit-btn').prop('disabled', true);
  }
}


/****************************************************************************
* 商品読み込み後に表示
****************************************************************************/
function displayedAfterLoadingProduct(){

　//loading後に、ページを表示
  $(window).on('load',function(){
    $('body').addClass('visible');
  });
  
}

/****************************************************************************
* 商品画像の矢印ボタンの処理
****************************************************************************/
function processingImageArrowButton(){
  
  //前へ、次へボタンを表示
  $('.product-single__media-group').prepend('<div class="customize-prev-btn"></div>');
  $('.product-single__media-group').append('<div class="customize-next-btn"></div>');

  //動作
  var activeIndex;
  
  //「＜」の矢印ボタンをクリックしたとき
  $(document).on("click", ".customize-prev-btn", function () {
    //カレント画像が何番目かを取得
    activeIndex = $('.active-thumb').index('.product-single__thumbnail--product-template');

    //一枚目の場合
    if( activeIndex == 0 ){
      //処理終了
      return false;
    }

    //ひとつ前の画像を表示
    //$('.product-single__thumbnail--product-template').eq(activeIndex - 1).click();
    document.getElementsByClassName("product-single__thumbnail--product-template")[activeIndex - 1].dispatchEvent(new Event('click'));

    //カレントのサムネイルが表示されるようスクロール
    scrollCurrentThumbnailImageArea();

  });

  //「＞」の矢印ボタンをクリックしたとき
  $(document).on("click", ".customize-next-btn", function () {
    //カレント画像が何番目かを取得
    activeIndex = $('.active-thumb').index('.product-single__thumbnail--product-template');

    //最後の画像の場合、処理終了
	if( activeIndex == $('.product-single__thumbnail--product-template').length-1 ){
      return false;
    }

    //ひとつ後の画像を表示
    //$('.product-single__thumbnail--product-template').eq(activeIndex + 1).click();
    document.getElementsByClassName("product-single__thumbnail--product-template")[activeIndex + 1].dispatchEvent(new Event('click'));
    
    //カレントのサムネイルが表示されるようスクロール
    scrollCurrentThumbnailImageArea();

  });
  
}
    
/****************************************************************************
* カレントのサムネイルが左端に表示されるようスクロール
****************************************************************************/
function scrollCurrentThumbnailImageArea(){
  
  //端末がPCの場合
  if( isPC() ){
    
    //カレントの画像のX座標を取得
    var activeLeftPosition = $('.active-thumb').offset().left;

    //サムネイル表示箇所のX座標を取得
    var areaLeftPosition = $('.product-single__thumbnails').offset().left;

    //差分を計算
    var differencePixcel = activeLeftPosition - areaLeftPosition;

    //横スクロール量を取得
    var scrollAmount = parseInt($('#mCSB_1_container').css('left'));

    //スクロール分
    var scrollPixcel = scrollAmount - differencePixcel;

    //サムネイルの非表示部分 = サムネイル全体の横幅 - サムネイル表示部分の横幅
    var hideThumbnailWidth = $('.mCSB_container').width() - $('.mCustomScrollBox').width();

    //差分だけサムネイル画像をスクロール
    if( -(scrollPixcel) < hideThumbnailWidth ){
      $('#mCSB_1_container').css('left', scrollPixcel);

    //最後までサムネイル画像をスクロール
    }else{
      $('#mCSB_1_container').css('left', -(hideThumbnailWidth));
    }
    
  //端末がスマホの場合
  }else{
    //カレントの画像のX座標を取得
    var activeLeftPosition = $('.active-thumb').position().left;

    //サムネイル表示箇所のX座標を取得
    var areaLeftPosition = $('.product-single__thumbnails-slider-track').offset().left;

    //差分を計算
    //var differencePixcel = activeLeftPosition - areaLeftPosition;

    //横スクロール量を取得
    var scrollAmount = $('.product-single__thumbnails-slider-track').scrollLeft();

    //差分だけサムネイル画像をスクロール
    $('.product-single__thumbnails-slider-track').scrollLeft( activeLeftPosition + scrollAmount );
  }
  

}

/****************************************************************************
* ページ上部の余白調整
****************************************************************************/
function adjustMarginsTopOfPage(){
  
  //告知バーがある場合
  if( $( '.announcement-bar' ).length ){
    
    //ヘッダーの高さを取得
    var headerHeight = $( '[data-header-section]' ).height();

    //告知バーの高さを取得
    var announcementHeight = $( '.announcement-bar' ).height();
    
    //PCの場合
    if( isPC() ){
      
      //Top page
      if($( '.template-index' ).length){
        //console.log( "pc:"+announcementHeight );
        //メインコンテンツの上部に余白を追加
        $( '.main-content' ).css( 'padding-top', announcementHeight );
      }else{
        //console.log( "pc:"+announcementHeight + headerHeight );
        //メインコンテンツの上部に余白を追加
        $( '.main-content' ).css( 'padding-top', announcementHeight + headerHeight );
      }
      
    //SPの場合
    }else{
      //console.log( "sp:"+headerHeight );
      //メインコンテンツの上部に余白を追加
      $( '.main-content' ).css( 'padding-top', headerHeight );
    }
  }
}


/*
 * 予約商品のボタン文言変更
 */
function displayPreorderBtn(){
  if($('.preorder_cart_btn').length) {
    var cartBtnDisabled = $('.preorder_cart_btn').find('button[type="submit"]').attr('aria-disabled');
    if( cartBtnDisabled == 'true' ) {
      $('.preorder_cart_btn').find('button[type="submit"]').text('売り切れ');
    } else {
      $('.preorder_cart_btn').find('button[type="submit"]').text('予約');
    }
  }
}

/*
 * アイコンの表示制御
 */
function controlProductIconDisplay(serverResponse){

  var newIconClass = '.list-badge.badge--new';//新商品タグのclass名
  var comingIconClass = '.list-badge.badge--comingsoon';//ComingSoonタグのclass名
  var gridItemClass = '.product-card';//グリッドの各商品を括っているclass名
  var productItem;

  //新商品タグの数分処理
  for( var i=0; i<$( newIconClass ).length; i++ ){
    //各商品のDOMを取得
    productItem = $( newIconClass ).eq(i).parents( gridItemClass );
    if( productItem.length ){
      //新商品アイコンの表示制御
      mainControlNewProductIconDisplay( serverResponse, productItem );
    }
  }

  //comingsoonタグの数分処理
  for( var i=0; i<$( comingIconClass ).length; i++ ){
    //各商品のDOMを取得
    productItem = $( comingIconClass ).eq(i).parents( gridItemClass );
    if( productItem.length ){
      //comingsoonアイコンの表示制御
      mainControlComingProductIconDisplay( serverResponse, productItem );
    }
  }

  //Product Page
  if( $( '.template-product' ).length ){
    productItem = $( '.product-single__meta' );
    if( productItem.length ){
      //新商品アイコンの表示制御
      mainControlNewProductIconDisplay( serverResponse, productItem );
      //comingsoonアイコンの表示制御
      mainControlComingProductIconDisplay( serverResponse, productItem );
    }
  }
}

/*
 * 新商品アイコンの表示制御（メイン処理）
 */
function mainControlNewProductIconDisplay( serverResponse, productItem ){

  var displayPeriod = 7;//新商品タグの表示期間
  var newIconClass = '.badge--new';//新商品タグのclass名

  //今日の日付を取得
  var today = new Date(serverResponse);

  //発売日を取得
  var releaseDateStr = productItem.find( '.js-release_date' ).text().trim();

  if(releaseDateStr) {
    var releaseDate = new Date(releaseDateStr);
    var releaseDateEnd = new Date(releaseDateStr);

    //表示期間の最終日を計算
    releaseDateEnd.setDate(releaseDateEnd.getDate() + displayPeriod);

    //表示期間を過ぎている
    if( today.getTime() > releaseDateEnd ){
      // 新商品タグを非表示
      productItem.find( newIconClass ).hide();
    }

    //発売日が先
    if( today.getTime() < releaseDate.getTime() ){
      // 新商品タグを非表示
      productItem.find( newIconClass ).hide();
    }

  } else {
    productItem.find( newIconClass ).hide();
  }
}


/*
 * ComingSoon表示制御（メイン処理）
 */
function mainControlComingProductIconDisplay( serverResponse, productItem ){
  var comingIconClass = '.badge--comingsoon';//ComingSoonタグのclass名

  //今日の日付を取得
  var today = new Date(serverResponse);

  //発売日を取得
  var releaseDateStr = productItem.find( '.js-release_date' ).text().trim();

  if(releaseDateStr) {
    var releaseDate = new Date(releaseDateStr);

    // 発売開始前
    productItem.find( comingIconClass ).hide();
    if( today.getTime() <= releaseDate.getTime() ){
      // Coming soonを表示
      productItem.find( comingIconClass ).show();
      // 発売日を表示
      productItem.find('.display__release_date').show();
      // 購入ボタンを非表示
      productItem.find( '.product-form__enable' ).remove();
      // 数量を非表示
      productItem.find('.quantity_selector').remove();
      // 入荷お知らせを非表示
      productItem.find('.illi-notify-restocks-accept-button').hide();
      // 購入できないボタンを表示
      productItem.find( '.js-release_date--disable' ).show();
    } else {
      productItem.find( comingIconClass ).hide();
      //購入ボタンを表示
      productItem.find( '.product-form__enable' ).show();
    }
  } else {
    productItem.find( comingIconClass ).hide();
    productItem.find( '.product-form__enable' ).show();
  }
}


/*
 * カートページ 発売開始前商品の購入制限
 */
function controlCartPurchaseReleaseDate( serverResponse ){

  var dateClass = '.js-release_date';
  var gridItemClass = '.cart__product-information';//グリッドの各商品を括っているclass名
  var productItem;

  //今日の日付を取得
  var today = new Date(serverResponse);

  //日付の設定がない場合は処理終了
  if( $( dateClass ).length < 1 ){
    return;
  }

  for( var i=0; i<$( dateClass ).length; i++ ){
    //各商品のDOMを取得
    productItem = $( dateClass ).eq(i).parents( gridItemClass );

    //購入制御
    if( productItem.length ){
      //発売日を取得
      var releaseDateStr = productItem.find( dateClass ).text().trim();
      var releaseDate = new Date(releaseDateStr);


      // 発売日前なら
      if( today <= releaseDate ){
        //購入ボタンを非表示にし、購入できないボタン・メッセージを表示
        $( '.js-cart__buttons-container' ).addClass( 'cart__submit__disable' );
        $( '.cart__submit__disable--note:not(.js-release_date--message)' ).hide();
        $( '.js-release_date--message' ).show();
        // ひとつでもあれば処理終了
        return;
      // 発売後
      }else{
        //購入ボタンを表示
        $( '.cart__submit' ).show();
      }
    }
  }
}

/*
 * 現在時刻をサーバーから取得して各種処理
 */
function processingMultipleGetServerDate(){
  $.ajax({
    type : 'HEAD',
    url :  window.location.href,
    cache : false
  }).done(function(data, textStatus, xhr) {
    try {
      var serverResponse = new Date(xhr.getResponseHeader("Date"));
    } catch(e) {
      var serverResponse = new Date();
    }

    //Top page
    if($( '.template-index' ).length){
      //新商品アイコンの表示制御
      controlProductIconDisplay(serverResponse);
    }

    //Collection Page / Search Page
    if( $( '.template-search' ).length || $( '.template-collection' ).length ){
      //新商品アイコンの表示制御
      controlProductIconDisplay(serverResponse);
    }

    //Product page / Cart page
    if( $( '.template-product' ).length > 0 || $( '.template-cart' ).length > 0 ){
      //新商品アイコンの表示制御
      controlProductIconDisplay(serverResponse);

      //発売開始前の購入制御
       controlCartPurchaseReleaseDate(serverResponse);
    }


  }).fail(function() {
    var serverResponse = new Date();
    // 失敗時の制御
    console.log('Server Date error')
  });

}

/****************************************************************************
* StoreFrontAPI 商品情報取得
****************************************************************************/
function productApiCall( query ) {
  var shopName = 'mischmasch-shop.myshopify.com';
  var storeFrontToken = 'c694490924067996e52e0ba9ed84e17e'; //Storefront APIのアクセストークンを入力
  return fetch('https://' + shopName + '/api/2023-01/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/graphql',
      'X-Shopify-Storefront-Access-Token': storeFrontToken
    },
    "body": query
  }).then(response => response.json());
}

/****************************************************************************
* ウィッシュリスト用の予約商品制御
****************************************************************************/
function wishlistCartCheck(releaseDateStr){
  return $.ajax({
    type : 'HEAD',
    url :  window.location.href,
    cache : false
  }).then(function(data, textStatus, xhr) {
    try {
      var serverResponse = new Date(xhr.getResponseHeader("Date"));
    } catch(e) {
      var serverResponse = new Date();
    }

    //今日の日付を取得
    var today = new Date(serverResponse);

    var releaseDate = new Date(releaseDateStr);

    // 発売開始前
    if( today.getTime() < releaseDate.getTime() ){
      // 買えない
      return 'unavailable';
    } else {
      // 買える
      return 'available';
    }
  });

}
